import { useSelector } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useIsBetbookDesktopLayout } from '../useMediaQuery';
import { isNativeSelector } from '../../redux/reducers/app/params';
import FEATURES from '../../constants/featureToggling';

export const useIsExternalNavbarEnabled = () => {
  const isFeatureEnabled = useFeatureIsOn(FEATURES.COMMON_NAVBAR);
  const isNative = useSelector(isNativeSelector);
  const isDesktop = useIsBetbookDesktopLayout();

  return isFeatureEnabled && !isNative && !isDesktop;
};
